const DummyCB = ({ x, y }) =>{
    return (
      <g id="CB3">
        <line
          x1={ x}
          y1={"368"}
          x2={ x}
          y2={"269"}
          id="Line-2"
          strokeWidth="3"
          strokeDasharray="4 8"
          strokeLinecap="round"
          stroke="var(--se-sld-circline)"
        // strokeLinejoin="round"
        ></line>
      </g>
    );
}
export default DummyCB;